import React from 'react';
import PropTypes from 'prop-types';
import { renderWeight } from '../../../../../Utils/weight_utils';
import UserInfo from '../../../../../UserInfo';

const weightPrecision = UserInfo.getInstance(UserInfo.getInstanceID()) ? UserInfo.getInstance(UserInfo.getInstanceID()).weightPrecision : null

const Weight = ({ value }) => {

    if ([null, undefined, "", "N/A"].includes(value)) {
        return value;
    }

    const kg = 0.453592;
    const weightUnits = UserInfo.weightUnits;
    const weight = `
        ${parseFloat(weightUnits === 'Kgs' ? value * kg : value).toFixed(UserInfo.getInstance(UserInfo.getInstanceID()).weightPrecision)} ${weightUnits}.
    `

    return (
        <span>
            {renderWeight(value, weightPrecision || 3, weightPrecision || 2)}
        </span>
    );
};

Weight.propTypes = {
    value: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]).isRequired
};

Weight.defaultProps = {};

export default Weight;
